import { render } from "./ProteinNameSearch.vue?vue&type=template&id=8c70d4f0"
import script from "./ProteinNameSearch.vue?vue&type=script&lang=js"
export * from "./ProteinNameSearch.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__